import { cn } from "../../utilities/tailwind";

export const DaysOfWeek = ({
  className,
}: {
  className?: string | undefined;
}) => (
  <div className={cn("grid grid-cols-7 text-center text-dark-gray", className)}>
    <div>S</div>
    <div>M</div>
    <div>T</div>
    <div>W</div>
    <div>T</div>
    <div>F</div>
    <div>S</div>
  </div>
);
DaysOfWeek.displayName = "Calendar.DaysOfWeek";
